import { Icon } from '../atoms'

export interface MapControlsProps {
  onZoomIn: () => void
  onZoomOut: () => void
}

export const MapControls = ({ onZoomIn, onZoomOut }: MapControlsProps) => {
  return (
    <>
      <button
        onClick={onZoomIn}
        className="absolute bottom-[68px] right-3 w-[46px] h-[46px] rounded-xl border border-border-muted bg-background-elevated/95 backdrop-blur-md flex items-center justify-center cursor-pointer z-[800] select-none shadow-lg hover:bg-background-card transition-colors active:scale-[0.95]"
        title="Zoom in (or use mouse wheel)"
        aria-label="Zoom in"
      >
        <Icon name="zoom-in" className="w-5 h-5 text-text" />
      </button>
      <button
        onClick={onZoomOut}
        className="absolute bottom-3 right-3 w-[46px] h-[46px] rounded-xl border border-border-muted bg-background-elevated/95 backdrop-blur-md flex items-center justify-center cursor-pointer z-[800] select-none shadow-lg hover:bg-background-card transition-colors active:scale-[0.95]"
        title="Zoom out (or use mouse wheel)"
        aria-label="Zoom out"
      >
        <Icon name="zoom-out" className="w-5 h-5 text-text" />
      </button>
    </>
  )
}
